import { getCategoriesByIds } from "@/requests/category";
import useFetch from "./useFetch";

const useCategoriesById = ({
    widget
}: {
    widget?: Widget
}) => {
    
    const {
        response: categories,
        loading,
        error
    } = useFetch(
        () => getCategoriesByIds(widget?.category?.map(c => c.id) || []), {}
    )

	return {
        categories,
        loading,
        error
    }
}

const useCategoriesByIdWithInterceptors = () => {
	return [];
}

// ** exports
export default useCategoriesById;
export { useCategoriesByIdWithInterceptors };